<template>
    <div class="landing-page d-flex flex-column">
        <!-- <AnnouncementBanner /> -->

        <div class="top-vector-floating">
            <div id="scene1" data-relative-input="true">
                <div data-depth="0.2">
                    <img
                        src="/images/landing-page/floating-top-left-1.svg"
                        alt="vector floating"
                        class="position-absolute floating-top-left-1"
                    />
                </div>
                <div data-depth="0.3">
                    <img
                        src="/images/landing-page/floating-top-left-2.svg"
                        alt="vector floating"
                        class="position-absolute floating-top-left-2"
                    />
                </div>
                <div data-depth="0.4">
                    <img
                        src="/images/landing-page/floating-top-center.svg"
                        alt="vector floating"
                        class="position-absolute floating-top-center"
                    />
                </div>
                <div data-depth="0.5">
                    <img
                        src="/images/landing-page/floating-top-right-1.svg"
                        alt="vector floating"
                        class="position-absolute floating-top-right-1"
                    />
                </div>
                <div data-depth="0.6">
                    <img
                        src="/images/landing-page/floating-top-right-2.svg"
                        alt="vector floating"
                        class="position-absolute floating-top-right-2"
                    />
                </div>
            </div>

            <Header />

            <div
                class="flex-shrink-1 flex-grow-1 position-relative hero__container"
            >
                <div class="hero__text-container">
                    <div>
                        <span>Diversified</span> <br />
                        High Organic Yield
                    </div>
                    <a href="https://stronghold.thetanuts.finance/">
                        <AppButton class="text-uppercase">
                            Swap Now
                        </AppButton>
                    </a>
                </div>
                <div class="audited-by__container">
                    <span>Audited By </span>
                    <div>
                        <img
                            src="/images/landing-page/audited-by/audited-by-zokyo.png"
                        />
                        <img
                            src="/images/landing-page/audited-by/audited-by-x41.png"
                        />
                        <img
                            src="/images/landing-page/audited-by/audited-by-akira-tech.png"
                        />
                        <img
                            src="/images/landing-page/audited-by/audited-by-peckshield.svg"
                            class="peckshield"
                        />
                    </div>
                </div>
            </div>
        </div>

        <Partners />
        <OurProduct />
        <OurMission />
        <Footer hoverColor="green" />
    </div>
</template>

<script>
import AppButton from "../components/LandingPage/AppButton.vue";
import Header from "../components/LandingPage/Header.vue";
import Partners from "../components/LandingPage/Partners.vue";
import OurProduct from "../components/LandingPage/OurProduct.vue";
import OurMission from "../components/LandingPage/OurMission.vue";
import Footer from "../components/LandingPage/Footer.vue";
import Parallax from "parallax-js";
import AnnouncementBanner from "../components/AnnouncementBanner.vue";

export default {
    components: {
    Header,
    AppButton,
    Partners,
    OurProduct,
    OurMission,
    Footer,
    AnnouncementBanner
},
    data() {
        return {};
    },
    mounted() {
        var scene = document.getElementById("scene1");
        var parallaxInstance = new Parallax(scene);
        this.sendPageview()
    },
    methods:{
        sendPageview() {
            if (typeof gtag === 'function') {
            gtag('config', 'G-V5B2E9WV92', {
                page_path: '/landing',
                page_title: 'Landing Page',
            });
            }
        },
    }
};
</script>

<style lang="scss" scoped>
@import "../../sass/landing-page/landing-page.css";

#scene1 {
    height: 75vh;
    width: 100vw;
    max-width: 100%;
    position: absolute;

    > div {
        width: 100%;
        height: 100%;
    }
}

.top-vector-floating {
    position: relative;
    // z-index: 1;
    z-index: 5;
}

.floating-top-left-1 {
    width: 101px;
    left: 10%;
    bottom: 10%;
    animation: floatingTop1 10s infinite alternate-reverse;

    @media only screen and (min-width: 1440px) {
        width: 171px;
    }
}
.floating-top-left-2 {
    width: 47px;
    left: 2%;
    top: 40%;
    animation: floatingTop2 12s infinite alternate-reverse;

    @media only screen and (min-width: 1440px) {
        width: 77px;
    }
}
.floating-top-center {
    width: 70px;
    left: 35%;
    top: -2%;
    animation: floatingTop3 15s infinite alternate-reverse;

    @media only screen and (min-width: 1440px) {
        width: 120px;
    }
}
.floating-top-right-1 {
    width: 66px;
    right: 25%;
    top: 30%;
    animation: floatingTop4 13s infinite alternate-reverse;

    @media only screen and (min-width: 1440px) {
        width: 96px;
    }
}
.floating-top-right-2 {
    width: 103px;
    right: 10%;
    bottom: 10%;
    animation: floatingTop5 2s infinite alternate-reverse;

    @media only screen and (min-width: 1440px) {
        width: 153px;
    }
}

.landing-page {
    background: url("/images/landing-page/bg-c.jpg");
    min-height: 100vh;
    color: #fff;
    overflow-x: hidden;
}
.hero__container {
    padding-top: 60px;

    @media only screen and (min-width: 768px) {
        padding-top: 0px;
    }
}
.hero__text-container {
    font-family: Poppins;
    font-size: 51px;
    font-style: italic;
    font-weight: 400;
    line-height: 57px;
    letter-spacing: 0px;
    text-align: center;

    @media only screen and (min-width: 1440px) {
        font-size: 70px;
        line-height: 77px;
    }

    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 70vh;

    span {
        font-weight: 700;
        background-image: linear-gradient(
            95.12deg,
            #1cc8c1 0%,
            #05feb1 0.01%,
            #d9ef46 28.64%,
            #ff843f 49.48%,
            #a2f9e4 73.96%,
            #05feb1 100%
        );
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;

        background-size: 300%;
        background-position: -100%;

        animation: animatedText 5s infinite alternate-reverse;
    }
}

.audited-by__container {
    background: rgba(18, 25, 25, 0.5);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    width: max-content;
    min-height: 55px;
    position: absolute;
    bottom: 5%;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 15px;
    padding: 10px 20px;
    backdrop-filter: blur(4px);

    @media only screen and (min-width: 1440px) {
        width: max-content;
        min-height: 75px;
        padding: 15px 26px;
        border-radius: 20px;
    }

    span {
        font-family: Sofia Sans;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 30px;
        letter-spacing: 0.5px;
        text-align: center;
        text-transform: uppercase;
        margin-bottom: 5px;

        @media only screen and (min-width: 1440px) {
            font-size: 18px;
            line-height: 30px;
            letter-spacing: 0.5px;
        }
    }

    img {
        width: 73px;

        @media only screen and (min-width: 1440px) {
            width: 113px;
            &.peckshield{
                width: 200px;
            }
        }

        &:not(:last-child) {
            margin-right: 10px;
        }
    }
}

// Animations
@keyframes animatedText {
    to {
        background-position: 100%;
    }
}
@keyframes rotated {
    to {
        transform: rotate(360deg);
    }
}
@keyframes rotatedTop4 {
    0% {
        transform: rotate(0deg);
    }
    40% {
        transform: rotate(50deg);
    }
    80% {
        transform: rotate(-50deg);
    }
}
@keyframes floatingTop1 {
    0% {
        left: 8%;
        bottom: 13%;
    }
    20% {
        left: 7%;
        bottom: 9%;
    }
    40% {
        left: 10%;
        bottom: 12%;
    }
    60% {
        left: 7%;
        bottom: 7%;
    }
    80% {
        left: 8%;
        bottom: 12%;
    }
    100% {
        left: 10%;
        bottom: 10%;
    }
}
@keyframes floatingTop2 {
    0% {
        left: 1%;
        top: 45%;
    }
    20% {
        left: 4%;
        top: 40%;
    }
    40% {
        left: 6%;
        top: 30%;
    }
    60% {
        left: 3%;
        top: 35%;
    }
    80% {
        left: 1%;
        top: 30%;
    }
    100% {
        left: 2%;
        top: 40%;
    }
}
@keyframes floatingTop3 {
    0% {
        left: 37%;
        top: 0%;
    }
    20% {
        left: 34%;
        top: -1%;
    }
    40% {
        left: 34%;
        top: 2%;
    }
    60% {
        left: 38%;
        top: 1%;
    }
    80% {
        left: 40%;
        top: 3%;
    }
    100% {
        left: 35%;
        top: -2%;
    }
}
@keyframes floatingTop4 {
    0% {
        right: 22%;
        top: 28%;
    }
    20% {
        right: 24%;
        top: 31%;
    }
    40% {
        right: 27%;
        top: 27%;
    }
    60% {
        right: 28%;
        top: 30%;
    }
    80% {
        right: 30%;
        top: 33%;
    }
    100% {
        right: 25%;
        top: 30%;
    }
}
@keyframes floatingTop5 {
    0% {
        right: 10%;
        bottom: 8%;
    }
    100% {
        right: 10%;
        bottom: 10%;
    }
}
</style>
